
import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();
  const [timeoutReached, setTimeoutReached] = useState(false);
  
  console.log('AdminRoute - Current state:', { 
    hasUser: !!user, 
    isAdmin, 
    loading, 
    timeoutReached,
    pathname: location.pathname 
  });
  
  useEffect(() => {
    // Set a timeout to prevent infinite loading
    const timeout = setTimeout(() => {
      console.log('AdminRoute - Timeout reached');
      setTimeoutReached(true);
    }, 3000); // Reduced to 3 seconds

    return () => clearTimeout(timeout);
  }, []);

  // If we have a user and they're admin, show the content
  if (user && isAdmin) {
    console.log('AdminRoute - Rendering admin content');
    return <>{children}</>;
  }

  // If we're still loading and haven't timed out, show loading
  if (loading && !timeoutReached) {
    console.log('AdminRoute - Still loading...');
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="text-sm text-muted-foreground">Loading admin panel...</p>
        </div>
      </div>
    );
  }

  // If no user or not admin, redirect to login
  console.log('AdminRoute - Redirecting to login');
  return <Navigate to="/admin/login" state={{ from: location }} replace />;
}
